module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Poetry from the Heart")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#the-writer"
    }
  }, [_vm._v("1. The Writer")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#the-buskers"
    }
  }, [_vm._v("2. The Buskers")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#tom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Tom")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#pop-wilkie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Pop Wilkie")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-albert-clock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Albert Clock")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#roy-rogers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Roy Rogers")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-markets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Markets")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#ma-cassidy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Ma Cassidy")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#from-america",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. From America")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#tyrella",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Tyrella")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-magic-harp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Magic Harp")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-beavers-and-the-wolf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Beavers and the Wolf")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-lords-of-lagan-lane",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Lords of Lagan Lane")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#sadie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Sadie")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#a-day-in-omeath",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. A Day in Omeath")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#the-old-men",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Old Men")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#bap-finch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Bap Finch")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-confessional",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The Confessional")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0